<div class="dialogCustom--fixedHeight">
  <div mat-dialog-title>
    <div class="d-flex flex-column">
      <div class="h4 mb-0">{{title}}</div>
    </div>

    <button class="align-self-start" mat-icon-button (click)="onCancel()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="noPadding">
    <nav mat-tab-nav-bar mat-stretch-tabs="false" [tabPanel]="tabPanel">
      <a
        [routerLink]="[]"
        [queryParams]="{ modal:'info', entity:context.data.id,selectedTab: DprForecastData.CustomData  }"
        [replaceUrl]="true"
        (click)="activeLink = DprForecastData.CustomData"
        [active]="activeLink === DprForecastData.CustomData"
        mat-tab-link
      >
        <span i18n="@@dprDetails.dprEditForecastActivityModal.btnCustomData">Custom Data</span>
      </a>
      <a
        *ngIf="!isMilestoneActivity"
        [routerLink]="[]"
        [queryParams]="{ modal:'info', entity:context.data.id,selectedTab: DprForecastData.Subactivities  }"
        [replaceUrl]="true"
        (click)="activeLink = DprForecastData.Subactivities"
        [active]="activeLink === DprForecastData.Subactivities"
        mat-tab-link
      >
        <span i18n="@@dprDetails.dprEditForecastActivityModal.btnSubactivities">Sub Activities</span>
      </a>
    </nav>

    <mat-tab-nav-panel #tabPanel>
      <div [hidden]="activeLink !== DprForecastData.CustomData">
        <app-dpr-edit-activity-custom-data-grid
          #customDataGrid
          [canEdit]="context.allowEditing"
          [gridData]="dprActivityCustomDataGridData"
          [dprLockedDate]="data.context.additionalData.dprLockedDate"
          [customDataList]="customDataList"
          [customDataListValues]="customDataListValues"
          [activityId]="context.data.activityId"
          [activityMobilisation]="activityMobilisation"
          (gridRegistered)="onCustomDataGridRegistered($event)"
        ></app-dpr-edit-activity-custom-data-grid>
      </div>
      <div [hidden]="activeLink !== DprForecastData.Subactivities || isMilestoneActivity">
        <app-dpr-edit-activity-subactivities-grid
          #subActivitiesGrid
          [canEdit]="context.allowEditing"
          [gridData]="context.data.dprForecastSubActivities"
          (gridRegistered)="onSubActivitiesGridRegistered($event)"
        ></app-dpr-edit-activity-subactivities-grid>
      </div>
    </mat-tab-nav-panel>
  </div>

  <div mat-dialog-actions class="buttonsWrapper">
    <button mat-flat-button color="primary" (click)="onDone()" cdkFocusInitial>
      <mat-icon svgIcon="check"></mat-icon>
      <span>{{StaticMessage.DoneButton | staticMessage}}</span>
    </button>
    <button mat-button color="primary" (click)="onCancel()">{{StaticMessage.CancelButton | staticMessage}}</button>
  </div>
</div>
